// i18n area 'backups' — locale nl-NL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.nl-NL.meta.json.
import type { enUS } from './backups'

export const nlNL: typeof enUS = {
  ckpt: {
    contents: 'Accepteert',
    contentsHint:
      "Wat hier mag landen. 'Checkpoints' is de clusterconfiguratie, 'Databack-ups' zijn die van de VM's: de twee lezingen vullen elkaar aan, één bestemming mag beide accepteren.",
    content: { checkpoints: 'Checkpoints', backups: 'Databack-ups' },
    destinationsTitle: 'Backupbestemmingen',
    checkpointsTitle: 'Checkpoints',
    restoreTitle: 'Herstel',
    addDestination: 'Target toevoegen',
    addDestinationTitle: 'Backupbestemming toevoegen',
    editDestinationTitle: 'Target bewerken',
    storage: 'Storage',
    storageHint:
      'Een dir-achtige storage (dir/NFS/CIFS/CephFS) — de artefacten zijn gewone bestanden onder de namespace van het platform.',
    schedule: 'Planning',
    scheduleNone: 'Alleen handmatig',
    scheduleHourly: 'Elk uur',
    scheduleDaily: 'Dagelijks',
    scheduleWeekly: 'Wekelijks',
    scheduleHour: 'Uur',
    scheduleWeekday: 'Dag',
    scheduleHint:
      'Bij geplande checkpoints is er geen operator die de masterpass typt: de secrets uit de keystore worden als placeholders ingepakt.',
    retention: 'Retentie',
    retentionHint:
      'Hoeveel geplande checkpoints je bewaart — de sweeper ruimt de oudste boven dat aantal op. Handmatige en pre-herstel-checkpoints worden nooit opgeruimd.',
    paused: 'Gepauzeerd',
    pausedHint:
      'De blackout van de operator: zolang de pauze duurt, wordt er op deze bestemming niets gepland en niets gesnoeid — datapolicies en checkpoints evengoed. Lopende runs worden nooit aangeraakt.',
    orphanRuns: '{n} verweesde runs',
    orphanRunsHint:
      'Geplande runs van policies die niet meer op deze bestemming bestaan: geen enkele retentie bestuurt ze — nooit geteld, nooit opgeruimd — en alleen een hand verwijdert ze. De lens „backups” van tvirt diagnose noemt de verwijderde policies.',
    rescan: 'Artefacten heradopteren',
    rescanTitle: 'Heradoptie van artefacten van {name}',
    rescanHint:
      'Bouwt de back-upcatalogus (VM/CT/App) opnieuw op uit de manifesten van de artefacten op de bestemming. Bestaande rijen worden nooit aangeraakt; back-ups van onbekende policy’s blijven wezen (nooit automatisch gesnoeid). De stap na een bootstrap-herstel.',
    masterpassDrWarning:
      'Rampscenario: LUKS-schijven komen ALLEEN terug uit een checkpoint MET masterpass. Geplande checkpoints pakken tijdelijke aanduidingen in — maak periodiek een handmatige checkpoint met masterpass.',
    policy: {
      title: 'Policies voor databack-ups',
      hint: 'Benoemde policies: welke objecten (kind, tags, scopes), hoe vaak, wanneer een run mag starten en hoeveel kopieën je bewaart. Het gebaar van inlijving blijft bij de eigenaar van het object: tags wijs je toe op zijn eigen scope.',
      add: 'Policy toevoegen',
      column: 'Datapolicies',
      name: 'Naam',
      nameHint:
        'Label van de policy, uniek binnen de bestemming. De runs volgen de stabiele id van de policy: hernoemen is gratis; verwijderen maakt haar runs wees (niet meer geteld of opgeruimd).',
      kindLocked: 'De objectfamilie van een bestaande policy kan niet veranderen: maak een nieuwe policy.',
      kindLabel: 'Objecten',
      kind: { vm: 'Virtuele machines', ct: 'Containers', app: 'Apps' },
      tags: 'Tag-selector',
      tagsHint: "Paren tag=waarde, kommagescheiden, in AND. Lege tags en scopes selecteren niets — nooit 'alles'.",
      scopes: 'Scopes',
      scopesHint: 'Scope-paden (subbomen), kommagescheiden, onderling in OR.',
      windowStart: 'Venster van',
      windowEnd: 'Venster tot',
      windowHint:
        'Uitvoeringsvenster (HH:MM, lokale tijd; een begin voorbij het einde gaat over middernacht heen). Het bewaakt alleen de START: een run die eroverheen loopt wordt nooit gedood.',
      mode: 'Modus',
      modeHint:
        'Incrementeel rijdt mee op de seriefamilie; een gebroken serie degradeert naar een full, gemeld in het journaal.',
      modeFull: 'Full',
      modeIncremental: 'Incrementeel',
      requireQuiesce: 'Quiesce vereisen (guest agent)',
      paused: 'Policy gepauzeerd',
      retentionNone: 'Alles bewaren',
      retentionCount: 'Aantal',
      retentionGfs: 'GFS-ringen',
      gfs: {
        keepLast: 'Laatste',
        daily: 'Dagelijks',
        weekly: 'Wekelijks',
        monthly: 'Maandelijks',
        yearly: 'Jaarlijks'
      },
      gfsHint:
        'Per ring wordt de nieuwste back-up van elk van de laatste N periodes bewaard. Een bewaarde back-up houdt zijn hele keten in leven — nooit een basis met wezen.',
      lastRun: 'Laatste run',
      neverRan: 'nooit uitgevoerd'
    },
    lastCheckpoint: 'Laatste checkpoint',
    neverRun: 'Nooit gemaakt',
    createNow: 'Checkpoint maken',
    createNowTitle: 'Checkpoint maken — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Beschermt de secretwaarden in de keystore (argon2id → AES-256-GCM, per waarde). Hij wordt nooit opgeslagen: bewaar hem — zonder de masterpass levert een herstel placeholders op in plaats van de echte secrets.',
    masterpassEmptyHint: 'Laat leeg om expliciete placeholders in te pakken in plaats van de secrets.',
    createStarted: 'Checkpoint bezig…',
    destinationInUseError: "'{name}' bevat nog checkpoints — verwijder die eerst.",
    origin: 'Herkomst',
    originManual: 'handmatig',
    originSchedule: 'gepland',
    originPreRestore: 'pre-herstel',
    originPreChange: 'pre-wijziging',
    preChangeRetention: 'Pre-change-checkpoints',
    preChangeRetentionHint:
      'Leeg = uitgeschakeld. De eerste configuratie-write na een rustperiode bevriest hier de vorige toestand (oorsprong pre-wijziging); de nieuwste blijven bewaard tot het aantal — eigen, snoeibare retentie.',
    diffTitle: 'Wijzigingsvoorbeeld',
    diffFailed: 'Voorbeeld mislukt',
    diffRetry: 'Opnieuw',
    diffCounts: '{changed} te wijzigen · {missing} te maken · {extra} overtollig · {equal} identiek',
    diffChanged: 'wijzigt',
    diffMissing: 'zou worden aangemaakt',
    diffExtra: 'zou worden verwijderd',
    diffJsonb: 'jsonb-verwijzingen niet verifieerbaar vóór het toepassen',
    diffSecret: 'verzegelde velden, niet vergelijkbaar',
    diffMore: 'nog {n}…',
    diffNeeded: 'De start wordt actief zodra het voorbeeld de selectie weerspiegelt.',
    phase: 'Status',
    phaseRunning: 'bezig',
    phaseComplete: 'compleet',
    phaseError: 'fout',
    secrets: 'Secrets',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'placeholders',
    size: 'Grootte',
    created: 'Aangemaakt',
    destination: 'Target',
    download: '.tvbk downloaden',
    deleteCheckpoint: 'Checkpoint verwijderen',
    noCheckpoints: 'Nog geen checkpoints — maak er een vanaf een bestemming.',

    // Round #156 (dialog standard): het volledige leesoppervlak van het
    // back-uprecord — detailregels voor de velden die de tabel nooit liet zien.
    families: 'Families',
    generation: 'Generatie',
    completedAt: 'Voltooid op',
    errorDetail: 'Foutdetail',
    manifest: 'Manifest',
    restoreHint:
      'Upload een .tvbk-artefact: de explorer laat zien wat erin zit, daarna kies je wat je herstelt en hoe.',
    uploadFile: 'Upload een .tvbk-bestand',
    uploading: 'Uploaden…',
    uploadFailed: 'Het artefact kon niet worden geopend',
    explorerTitle: 'Inhoud van het checkpoint',
    checkpointFrom: 'Checkpoint van cluster {cluster}, gemaakt op {when} ({origin}, generatie {generation})',
    otherCluster:
      'Dit checkpoint komt van een ANDER cluster ({cluster}) — herstel tussen clusters komt in een latere ronde.',
    encrypted: 'versleuteld',
    objectsCount: '{n} objecten',
    mode: 'Modus',
    modeMerge: 'Merge — reconciliëren: upsert van de geselecteerde rijen, verwijdert niets',
    modeOverwrite:
      'Overwrite — het checkpoint wint: een volledig geselecteerde familie wordt in zijn geheel vervangen (huidige rijen die niet in het checkpoint staan, sneuvelen)',
    restoreMasterpassHint:
      'De masterpass waarmee dit checkpoint is gemaakt. Zonder die masterpass worden versleutelde secrets hersteld als expliciete placeholders.',
    checkMasterpass: 'Controleren',
    masterpassOk: 'Masterpass correct',
    masterpassWrong: 'Masterpass onjuist',
    parachuteDestination: 'Parachute-bestemming',
    parachuteHint:
      'Voordat er ook maar één rij wordt aangeraakt, maakt de task hier automatisch een pre-herstel-checkpoint.',
    summaryTitle: 'Wat er gaat gebeuren',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'hele familie',
    summaryObjects: '{n} geselecteerde objecten',
    confirmHint:
      'Typ de naam van het cluster ({name}) om te bevestigen — een herstel schrijft de gedeclareerde configuratie opnieuw.',
    confirmField: 'Naam van het cluster',
    startRestore: 'Herstellen',
    restoreRunning: 'Herstel bezig…',
    restoreDone: 'Herstel voltooid — de reconcilers convergeren naar de nieuwe declaratie.',
    restoreFailed: 'Het herstel is mislukt',
    discard: 'Verwerpen',
    selectionEmpty: 'Selecteer minstens één familie of object.'
  },

  backup: {
    intro: {
      title: 'Back-up van VM- en containerdata',
      subtitle: 'De bouwstenen die externe back-upsoftware gebruikt',
      whatItIs:
        'TVirt stelt vier primitieven beschikbaar: quiesced snapshots, change tracking per schijf, read-only NBD-export en export van de configuratie. Veeam, Bacula, Acronis en consorten sturen ze aan.',
      whatItIsNot:
        'TVirt is geen back-upproduct: het plant niets, past geen retentie toe en bewaart geen archief van je data. Retentie, catalogi en herstelbeleid blijven bij de software die je al gebruikt.'
    },
    cbt: {
      title: 'Wijzigingsregistratie',
      colVm: 'VM',
      colDisk: 'Schijf',
      colState: 'Status',
      colBitmaps: 'Bitmaps',
      colObservedAt: 'Waargenomen',
      colChangeId: 'Change-ID',
      colMechanic: 'Mechanisme',
      stateActive: 'Actief',
      stateInactive: 'Uit',
      stateInconsistent: 'Inconsistent — de volgende back-up moet volledig zijn',
      stateBroken: 'Keten gebroken — uitschakelen, dan inschakelen als nieuwe keten',
      stateSnapshots: 'Altijd aan — delta tussen snapshots',
      stateUnavailable: 'Niet beschikbaar op deze schijf',
      mechanic: {
        'qcow2-bitmap': 'qcow2-bitmap',
        'rbd-snapdiff': 'Ceph-snapshotdiff',
        'lvm-thin-delta': 'Thin-pool-delta',
        none: 'Geen'
      },
      empty:
        'Geen VM-schijf. Wijzigingsregistratie wordt per schijf gelezen: schakel ze in op een qcow2-schijf, of maak snapshots op rbd/SAN.',
      chainBroken: 'Keten gebroken',
      chainBrokenText:
        'Gebroken door een {reason}: {bitmaps}. Schakel de bitmap uit (de keten is weg, de volgende back-up is volledig) en schakel ze in als nieuwe keten.',
      lineages: 'Tijdvakken',
      epochFrozen: 'bevroren in snapshot {snapshot}',
      epochLost: 'verloren ({cause})',
      epochRecording: 'opnemend op de kop',
      milestones: 'Snapshot-mijlpalen',
      enable: 'Registratie inschakelen',
      disable: 'Uitschakelen',
      reset: 'Resetten',
      changedAreas: 'Gewijzigde gebieden',
      denied: 'U mist de rechten op deze VM',
      enableTitle: 'Wijzigingsregistratie inschakelen',
      disableTitle: 'Wijzigingsregistratie uitschakelen',
      resetTitle: 'Bitmap resetten',
      areasTitle: 'Gewijzigde gebieden',
      bitmapName: 'Bitmapnaam',
      bitmapNameHint: 'Een eigen naam: tvirt- en tvbk- zijn van het platform',
      granularity: 'Granulariteit (bytes)',
      granularityHint: 'Een macht van twee; standaard 65536',
      bitmap: 'Bitmap',
      disableHint: 'Verwijdert de bitmap en haar hele tijdvakgeschiedenis: de volgende back-up moet volledig zijn.',
      resetHint: 'Leegt de bitmap — een nieuwe basis: een change-ID van vóór de reset is niet meer samenstelbaar.',
      areasFrom: 'Van snapshot',
      areasTo: 'Tot snapshot',
      areasRun: 'Berekenen',
      areasResult: '{count} gewijzigde gebieden, {bytes}',
      areasEmpty: 'Geen gewijzigd gebied tussen de twee snapshots',
      areasZero: 'nullen',
      areasMore: 'eerste {shown} van {count} getoond',
      submit: 'Bevestigen',
      error: 'De registratieactie is mislukt'
    },
    exports: {
      title: 'Open NBD-exports',
      colVm: 'VM',
      colDisk: 'Schijf',
      colSnapshot: 'Snapshot',
      colBitmap: 'Bitmap',
      colPhase: 'Fase',
      colNode: 'Node',
      colEndpoint: 'Endpoint',
      colExpires: 'Verloopt',
      colCreated: 'Geopend',
      colError: 'Fout',
      phase: {
        preparing: 'Voorbereiden',
        ready: 'Gereed',
        closed: 'Gesloten',
        error: 'Mislukt'
      },
      expiresIn: 'over {minutes} min',
      expired: 'verlopen',
      empty: 'Geen export. Een leessessie serveert één schijf op één snapshot aan een NBD-client; een schrijfsessie vult een maagdelijke schijf van een gestopte VM. Beide sterven bij het verlopen.',
      endpointHint: 'TLS met de cluster-CA; de exportnaam is het ticket — het sterft met de sessie',
      closeDenied: 'U mist de rechten om exports van deze VM te sluiten',
      open: 'NBD-export openen',
      openTitle: 'Een NBD-export openen',
      openDisk: 'Schijf',
      openBitmap: 'Bitmap (optioneel)',
      openBitmapHint:
        'Publiceert het in deze snapshot bevroren tijdvak van die bitmap als meta-context van de gewijzigde extents (alleen qcow2-schijven)',
      openTtl: 'Levensduur (minuten)',
      openSubmit: 'Openen',
      openError: 'De export kon niet worden geopend',
      colMode: 'Modus',
      mode: {
        read: 'Lezen',
        write: 'Schrijven'
      },
      caCertificate: 'Cluster-CA',
      caCopy: 'PEM kopiëren',
      caDownload: 'ca-cert.pem downloaden',
      caHint: 'Schrijf de PEM naar ca-cert.pem in een privémap en verbind met nbds://…?tls-certificates=<map> (nbdcopy, nbdinfo) of --object tls-creds-x509,dir=<map>,endpoint=client (qemu-img)',
      caAbsent: 'De sessie draagt geen CA (geen PKI)',
      openWrite: 'Schrijfexport openen',
      openWriteTitle: 'Een schrijfexport openen',
      openWriteIntro: 'De schijf moet maagdelijk zijn: leeg geboren, nooit beschreven, zonder snapshot; de VM gestopt. Het herstel VULT de schijf, het repareert hem niet. Zolang de sessie open is kan de VM niet starten, geen snapshot nemen, niet klonen en de schijf niet verplaatsen.',
      openWriteSubmit: 'Openen',
      openWriteError: 'De schrijfexport kon niet worden geopend',
      openWriteDenied: 'U mist vm.restore.data op deze VM',
      openWriteStopped: 'Stop de VM om een schrijfexport te openen',
      fromDescription: 'VM maken uit beschrijving',
      fromDescriptionTitle: 'Een VM maken uit een beschrijving',
      fromDescriptionIntro: 'De beschrijving van export-vm-meta komt terug als gestopte VM met lege schijven van de beschreven geometrie — klaar voor de schrijfexports, schijf voor schijf. De bytes gaan niet hierlangs: restore-disk (CLI) of de NBD-client van het backupproduct draagt ze.',
      fromDescriptionDoc: 'Beschrijving (JSON)',
      fromDescriptionDocHint: 'Plak het document van export-vm-meta, of kies het bestand',
      fromDescriptionFile: 'Bestand kiezen…',
      fromDescriptionInvalid: 'De tekst is geen JSON-document',
      fromDescriptionName: 'Naam van de nieuwe VM',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Uw thuisscope',
      fromDescriptionStorage: 'Schijfopslag',
      fromDescriptionStorageHint: 'Elke schijf wordt hier geboren, in het standaardformaat van de opslag',
      fromDescriptionMetadataStorage: 'Metadata-opslag',
      fromDescriptionSameAsStorage: 'Dezelfde als de schijven',
      fromDescriptionBridge: 'Bridge',
      fromDescriptionBridgeHint: 'Zonder bridge of netwerk wordt de VM zonder netwerkkaarten geboren',
      fromDescriptionNetwork: 'Logisch netwerk (fabric/netwerk)',
      fromDescriptionSubmit: 'Maken',
      fromDescriptionError: 'De VM kon niet worden gemaakt',
      fromDescriptionDone: 'VM gemaakt: {name}',
      fromDescriptionOpen: 'VM openen',
      fromDescriptionDenied: 'U mist vm.create',
      fromDescriptionStillRunning: 'Het aanmaken loopt nog: er wordt verder gewacht'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: "Databack-ups van de VM's",
      titleOnVm: 'Databack-ups',
      empty:
        'Geen back-up. Een back-up kopieert de schijven, de UEFI-varstore en de vTPM-status naar een bestemming, en overleeft de VM.',
      colVm: 'VM',
      colCreated: 'Gemaakt op',
      colPhase: 'Uitkomst',
      colDestination: 'Bestemming',
      colContains: 'Inhoud',
      colSize: 'Grootte',
      colOrigin: 'Herkomst',
      colMode: 'Type',
      retentionChip: 'Retentie',
      retentionHint:
        'De retentie van de bestemming kan deze back-up zonder vragen verwijderen: hij komt van een planning. Handmatige back-ups worden nooit opgeruimd.',
      policyRemoved: 'Policy verwijderd: {name}',
      policyRemovedHint:
        'De policy die deze backup plande bestaat niet meer: geen enkele retentie bestuurt hem (nooit automatisch opgeruimd) — verwijder hem met de hand als hij niet meer nodig is.',
      phase: {
        running: 'Bezig',
        complete: 'Voltooid',
        error: 'Mislukt'
      },
      origin: {
        manual: 'Handmatig',
        schedule: 'Gepland'
      },
      mode: {
        full: 'Volledig',
        incremental: 'Incrementeel'
      },
      contains: {
        disks: 'Schijven',
        varstore: 'UEFI-varstore',
        vtpm: 'vTPM-status',
        snapshots: 'Snapshots'
      },
      vmState: {
        stopped: 'VM uitgeschakeld',
        running: 'VM draait (warm)'
      },
      artifactClass: { metadata: 'Metadata', data: 'Data', secret: 'Geheim' },
      detail: {
        tabOverview: 'Overzicht',
        tabArtefact: 'Artefact',
        id: 'Identificatie',
        scope: 'Bereik',
        vmState: 'VM-status bij het kopiëren',
        pointInTime: 'Moment van de data',
        completedAt: 'Afgerond op',
        node: 'Node die kopieerde',
        error: 'Fout',
        path: 'Map op de opslag',
        checksum: 'sha256 van het manifest',
        secretsExposed: 'Gevoelig materiaal in leesbare vorm',
        secretsExposedYes: 'Ja — de bestemming versleutelt niet',
        secretsExposedNo: 'Nee',
        baseBackup: 'Basisback-up',
        tabManifest: 'Manifest',
        manifestHint:
          'De leesbare index van het artefact: één bestand per rij met zijn sha256. De map is ook zonder TVirt te verifiëren — qemu-img, tar en jq volstaan.',
        manifestEmpty: 'Het manifest noemt geen bestanden.',
        manifestError: 'Het manifest is niet leesbaar',
        colEntry: 'Bestand',
        colClass: 'Klasse',
        colSha: 'sha256'
      },
      create: {
        action: 'Nu back-uppen',
        title: 'Nu back-uppen',
        submit: 'Back-up starten',
        destination: 'Bestemming',
        destinationHint: 'Alleen bestemmingen die back-ups aannemen.',
        noDestinations: 'Geen enkele bestemming neemt back-ups aan: maak er een aan bij Systeem → Checkpoints.',
        contentsHint:
          'Alle schijven reizen mee, plus de UEFI-varstore en de vTPM-status. Die laatste twee zijn de kern: een verzegelde guest moet weer opstarten.',
        error: 'De back-up is niet gestart',
        stillRunning: 'Back-up nog bezig — de kopie loopt door, ook als u sluit.',
        vmRunning:
          'De VM is {phase}: een back-up vraagt een stabiele VM — uitgeschakeld voor de koude kopie, draaiend voor de warme.'
      },
      restore: {
        action: 'Terugzetten',
        title: 'Terugzetten',
        intro:
          'Terugzetten is onomkeerbaar. Kies waar de data terugkomt: in een nieuwe machine, of over de oorspronkelijke heen.',
        modeNewVm: 'Terugzetten in een NIEUWE VM',
        modeNewVmHint:
          'Raakt niets aan van wat bestaat — hiermee verifieert u een back-up. Nieuwe identificatie en vers geslagen MAC-adressen.',
        modeOver: 'De oorspronkelijke VM overschrijven',
        modeOverHint: 'Vernietigt de huidige data van de doel-VM, zonder weg terug. De VM moet uitgeschakeld zijn.',
        newName: 'Naam van de nieuwe VM',
        newNameHint: 'Hij moet vrij zijn in het doelbereik.',
        storage: 'Opslag voor de schijven',
        storageHint:
          'Verplicht: het manifest legt grootte en formaat van een schijf vast, nooit de opslag waar hij stond.',
        metadataStorage: 'Opslag voor varstore en vTPM',
        metadataStorageHint: 'Waar de UEFI-identiteit en de vTPM-status landen.',
        sameAsStorage: 'Dezelfde als de schijven',
        bridge: 'Bridge van de host',
        bridgeHint:
          'Elke geregistreerde netwerkkaart komt terug op deze bridge met een nieuw MAC-adres. Leeg gelaten wordt de VM zonder kaarten geboren — de veiligere standaard.',
        overwriteTitle: 'U staat op het punt deze VM te overschrijven',
        overwriteName: 'Naam',
        overwriteId: 'Identificatie',
        overwriteDisks: 'Schijven die worden overschreven',
        overwriteNoDisks: 'Geen schijf.',
        overwriteKeeps:
          'Onaangetast blijven identificatie, naam, bereik, netwerkkaarten en MAC-adressen: een back-up is de DATA, de configuratie is het checkpoint.',
        confirmField: 'Naam van de VM',
        confirmHint: 'Typ {name} om te bevestigen.',
        targetLoading: 'Doel-VM wordt gelezen…',
        targetRunning:
          'De doel-VM is {phase}: terugzetten herschrijft de bytes onder de guest, dus die moet uitgeschakeld zijn.',
        targetGone: 'De oorspronkelijke VM is niet meer leesbaar: terugzetten in een nieuwe VM blijft over.',
        onlyComplete: 'De back-up is {phase}: alleen een voltooide back-up kan terugzetten.',
        submitNewVm: 'Terugzetten in de nieuwe VM',
        submitOver: 'Overschrijven',
        error: 'Het terugzetten is niet gestart',
        stillRunning: 'Terugzetten nog bezig — hele schijven kopiëren kost tijd.'
      }
    },
    guest: {
      title: {
        ct: 'Databack-ups van containers',
        app: 'Databack-ups van Apps'
      },
      tabTitle: 'Back-ups',
      empty: 'Geen back-ups. Een back-up kopieert de persistente data naar een bestemming en overleeft zijn object.',
      colSubject: {
        ct: 'Container',
        app: 'App'
      },
      colCreated: 'Gemaakt',
      colPhase: 'Uitkomst',
      colDestination: 'Bestemming',
      colContains: 'Inhoud',
      colSize: 'Grootte',
      colOrigin: 'Oorsprong',
      policyRemoved: 'Policy verwijderd: {name}',
      policyRemovedHint:
        'De policy die deze backup plande bestaat niet meer: geen enkele retentie bestuurt hem (nooit automatisch opgeruimd) — verwijder hem met de hand als hij niet meer nodig is.',
      phase: {
        running: 'Bezig',
        complete: 'Voltooid',
        error: 'Mislukt'
      },
      origin: {
        manual: 'Handmatig',
        schedule: 'Gepland'
      },
      state: {
        stopped: 'Object gestopt',
        running: 'Object actief (bevroren)'
      },
      contains: {
        rootfs: 'Rootfs-boom',
        config: 'Configuratie',
        volumes: 'Persistente volumes',
        root: 'Persistente root'
      },
      artifactClass: {
        metadata: 'Metadata',
        data: 'Data',
        secret: 'Geheim'
      },
      create: {
        action: 'Nu back-uppen',
        title: 'Nieuwe back-up',
        submit: 'Back-up starten',
        error: 'De back-up is niet gestart',
        destination: 'Bestemming',
        destinationHint: 'Alleen bestemmingen die databack-ups accepteren.',
        noDestinations: 'Geen bestemming accepteert databack-ups: voeg “Databack-ups” toe aan een bestemming.',
        hint: {
          ct: "De hele rootfs-boom reist mee, getrouw (numerieke eigenaren, xattrs, ACL's), plus de gedeclareerde configuratie in het manifest. Een draaiende container wordt BEVROREN voor de duur van het inpakken: crash-consistente kopie, gedeclareerd.",
          app: 'ALLEEN de persistente volumes (en de persistente root) reizen mee, plus de configuratie in het manifest. Efemere delen zijn per ratificatie uitgesloten en het manifest benoemt ze; als geheim gedeclareerde env-waarden reizen niet mee.'
        },
        stillRunning: 'Back-up nog bezig — hele bomen inpakken kost tijd.'
      },
      detail: {
        tabOverview: 'Overzicht',
        tabManifest: 'Manifest',
        id: 'Identifier',
        scope: 'Scope',
        state: 'Toestand bij de kopie',
        pointInTime: 'Data per moment',
        completedAt: 'Afgerond',
        node: 'Node die kopieerde',
        error: 'Fout',
        path: 'Map op de storage',
        checksum: 'manifest-sha256',
        manifestHint:
          'De index van het artefact: één regel per bestand met zijn sha256 — zonder hashes is “de back-up is er” een geloofsdaad.',
        manifestError: 'Het manifest kan niet worden gelezen',
        manifestEmpty: 'Geen artefacten in het manifest.',
        colEntry: 'Bestand',
        colClass: 'Klasse',
        colSha: 'sha256',
        excluded: 'Uitgesloten per ratificatie (reist niet mee)',
        secretKeys: 'Weggelaten geheime env-sleutels (#307) — opnieuw invoeren na een restore'
      },
      restore: {
        action: 'Herstellen',
        title: 'Herstel',
        submit: 'Herstellen',
        error: 'Het herstel is niet gestart',
        stillRunning: 'Herstel nog bezig — hele bomen uitpakken kost tijd.',
        onlyComplete: 'De back-up is {phase}: alleen een voltooide back-up kan herstellen.',
        asNew: {
          ct: 'In een NIEUWE container — vernietigt niets: het gebaar waarmee je een back-up controleert',
          app: 'In een NIEUWE App — vernietigt niets: het gebaar waarmee je een back-up controleert'
        },
        over: {
          ct: 'OVER de broncontainer — de hele rootfs-boom wordt vervangen',
          app: 'OVER de bron-App — de inhoud van elk persistent volume wordt vervangen'
        },
        name: 'Naam van het nieuwe object',
        storage: 'Storage',
        storageHint: 'Waar de herstelde data landt — het manifest registreert nooit de verloren pool.',
        storageDeclared: 'De in het manifest gedeclareerde storages',
        bridge: 'Host-bridge',
        bridgeHint:
          'Elke geregistreerde NIC komt terug op deze bridge met een verse MAC. Leeg = geboren zonder verbinding, de veiligste default.',
        node: 'Node',
        nodeHint: 'Het lid waarop de App herboren wordt: de node is clusteridentiteit en komt nooit uit het manifest.',
        secretKeysWarning:
          'Als geheim gedeclareerde env-waarden reizen niet mee in de back-up: de herboren kopie wil ze opnieuw ingevoerd (het task-log noemt de sleutels).',
        overInventory: 'Je staat op het punt dit object te overschrijven',
        confirmType: 'Typ {name} om te bevestigen',
        targetGone: 'Het bronobject kan niet meer worden gelezen: herstellen als nieuw blijft beschikbaar.',
        targetLoading: 'Doelobject wordt gelezen…',
        targetRunning: 'Het doelobject draait: een herstel vervangt de bytes onder de gast en wil het dus gestopt.'
      }
    }
  }
}
